import React from 'react';
import { describeDueDate } from '../../utils/format';
import './common.css';

// Due date as "Thu 1 Oct" plus how far away it is ("In 3 days", "2 days overdue").
// Accepts ISO strings or `{ seconds }` timestamps. Pass `showRelative={false}` where
// urgency no longer matters (e.g. completed orders).
const DueDate = ({ date, inline = false, showRelative = true }) => {
  const due = describeDueDate(date);
  if (!due) return <span className="due-date">-</span>;
  const urgency = showRelative ? due.urgency : 'normal';
  return (
    <span className={`due-date due-${urgency} ${inline ? 'inline' : ''}`}>
      <span className="due-date-label">{due.label}</span>
      {showRelative && <span className="due-date-relative">{due.relative}</span>}
    </span>
  );
};

export default DueDate;
